import { ReferenceList } from "../../../../components/referenceList";
import { activeValue } from "../../../../components/collectionTools";
import {
  deleteAttributeGroup,
  updateAttributeGroup,
} from "../../../../api/attributes";
import { setAttributeSearch } from "../../../../reducers/userConfigSlice";
import { attributeValues } from "./attributeListModel";

export const AttributeList = ({ rows, onEdit }) => {
  const definition = {
    key: "attribute",
    idKey: "listId",
    singular: "atributo",
    plural: "atributos",
    nameLabel: "Atributo",
    searchKey: "attributeSearch",
    setSearch: setAttributeSearch,
    filterId: "attribute-type",
    filterLabel: "Tipo",
    filterOptions: () => [
      { value: "variant", label: "Variante" },
      { value: "attribute", label: "Atributo" },
    ],
    matchesFilter: (row, type) => row.type === type,
    searchText: (row) => `${row.name} ${attributeValues(row)}`,
    selectAllLabel: "Seleccionar todos los atributos de esta página",
    bulkRemove: false,
    editLabel: (row) =>
      row.type === "variant" ? "Editar variante" : "Editar atributo",
    canToggle: (row) => row.type === "attribute",
    canRemove: (row) => row.type === "attribute",
    remove: (ids) =>
      deleteAttributeGroup(
        rows.find((row) => row.listId === ids[0]).itemGroupId,
      ),
    toggle: (id) => {
      const row = rows.find((row) => row.listId === id);
      return updateAttributeGroup(row.itemGroupId, {
        isActive: !activeValue(row.isActive),
      });
    },
    columns: [
      {
        key: "type",
        label: "TIPO",
        render: (row) => (
          <span className={`attributeType ${row.type}`}>
            {row.type === "variant" ? "Variante" : "Atributo"}
          </span>
        ),
      },
      {
        key: "values",
        label: "VALORES",
        render: (row) => (
          <span className="attributeValues" title={attributeValues(row)}>
            {attributeValues(row)}
          </span>
        ),
      },
      {
        key: "products",
        label: "Productos",
        className: "catalogProductCount",
        render: () => (
          <span title="Recuento no disponible en este listado">—</span>
        ),
      },
    ],
    exportName: "atributos",
    exportColumns: [
      { label: "Atributo", value: (row) => row.name },
      {
        label: "Tipo",
        value: (row) => (row.type === "variant" ? "Variante" : "Atributo"),
      },
      { label: "Valores", value: attributeValues },
    ],
  };
  return (
    <>
      <ReferenceList
        rows={rows}
        definition={definition}
        onEdit={(row) => onEdit({ ...row, id: row.type === "variant" ? row.optionGroupId : row.itemGroupId })}
      />

    </>
  );
};
